// src/styles/components/MuiSkeleton.js
const MuiSkeleton = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.action.hover,
      transform: 'none',
    }),
    wave: ({ theme }) => ({
      '&::after': {
        background: `linear-gradient(90deg, transparent, ${theme.palette.action.selected}, transparent)`,
      },
    }),
  },
};

export default MuiSkeleton;